import EmployeeListingSpec from '@Components/Shared/Specs/EmployeeListingSpec';
import Modal from '@Components/Shared/Modals/Modal';
import translator from '@Components/Utilities/Translator';

const EmployeeArticleModal = (props) => {
    const {
        onEmployeeModalToggle,
        // these come from EmployeeArticleViewModel.cs
        ArticleID,
        ArticleTitle,
        ArticleSEOData
    } = props;

    return (
        <Modal onEscapeKeyClose={onEmployeeModalToggle}>
            <Modal.Header onClose={onEmployeeModalToggle}>
                <Modal.Title>
                    {ArticleTitle}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h4>
                    Article ID: {ArticleID}
                </h4>
                <section>
                    <EmployeeListingSpec title={translator.translate('sandhills.seometadata')} specs={ArticleSEOData} />
                </section>
            </Modal.Body>
        </Modal>
    );
};

export default EmployeeArticleModal;